import { useEffect } from 'react'
import { useAppSelector } from '@/store'
import { identifyUser, setUserProperties } from '@/utils/analytics'
import { useStoreData } from '@/hooks/useStoreData'
import { AUTH_STATUS } from '@/features/auth/constants'

export const usePostHogIdentification = () => {
    const { status, user, context } = useAppSelector((state) => state.auth)
    const { merchantId, storeId } = context
    const isAuthenticated = status === AUTH_STATUS.AUTHENTICATED
    const userEmail = user?.email
    const { data: storeData } = useStoreData()
    const merchantDetails = storeData?.store?.merchantDetails

    useEffect(() => {
        if (isAuthenticated && userEmail) {
            // Identify user with email as the primary identifier
            identifyUser(userEmail, {
                email: userEmail,
                merchant_id: merchantId,
                store_id: storeId,
                business_name: merchantDetails?.businessName,
                business_email: merchantDetails?.businessEmail,
                timezone: merchantDetails?.timezone,
                trial_ends_at: merchantDetails?.trialEndsAt,
                status: merchantDetails?.status,
            })

            // Set additional user properties
            setUserProperties({
                email: userEmail,
                merchant_id: merchantId,
                store_id: storeId,
                business_name: merchantDetails?.businessName,
                business_email: merchantDetails?.businessEmail,
                timezone: merchantDetails?.timezone,
                trial_ends_at: merchantDetails?.trialEndsAt,
                status: merchantDetails?.status,
                is_authenticated: true,
            })
        }
    }, [isAuthenticated, userEmail, merchantId, storeId, merchantDetails])
} 